import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';

const ExplanationCard = ({ title, children }) => {
  const { isDarkMode } = useTheme();
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div
      className="rounded-lg p-4 mb-4 border"
      style={{
        backgroundColor: isDarkMode ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.05)',
        borderColor: isDarkMode ? 'rgba(59, 130, 246, 0.3)' : 'rgba(59, 130, 246, 0.2)'
      }}
    >
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="flex items-center justify-between w-full text-left"
        style={{ background: 'none', border: 'none', padding: 0 }}
      >
        <h4
          className="text-base font-semibold flex items-center gap-2"
          style={{ color: isDarkMode ? '#93c5fd' : '#1d4ed8' }}
        >
          <span>💡</span>
          {title}
        </h4>
        <span
          className="text-sm"
          style={{
            color: isDarkMode ? '#60a5fa' : '#3b82f6',
            transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform 0.2s ease'
          }}
        >
          ▼
        </span>
      </button>
      {!isCollapsed && (
        <div
          className="text-sm mt-3 space-y-2"
          style={{ color: isDarkMode ? '#94a3b8' : '#4b5563' }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default ExplanationCard;
